import React from "react";

function IconHealth() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="54"
      height="54"
      viewBox="0 0 54 54"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g fillRule="nonzero" transform="translate(-568 -393)">
          <g transform="translate(230 366)">
            <g transform="translate(250)">
              <g transform="translate(88.459 27.444)">
                <path
                  fill="#FFF"
                  d="M31.993 1.848a5.862 5.862 0 015.854 5.84v5.817c0 1.02.827 1.848 1.848 1.848h5.825a5.862 5.862 0 015.854 5.862v10.778a5.854 5.854 0 01-5.854 5.854h-5.825a1.826 1.826 0 00-1.3.54 1.863 1.863 0 00-.548 1.308v5.825a5.854 5.854 0 01-5.854 5.854H21.23a5.862 5.862 0 01-5.855-5.854v-5.825c0-1.02-.827-1.848-1.848-1.848h-5.84a5.862 5.862 0 01-5.839-5.854V21.23c0-3.229 2.61-5.85 5.84-5.862h5.84c1.02 0 1.847-.827 1.847-1.848V7.688a5.862 5.862 0 015.855-5.84h10.763"
                 />
                <path
                  fill="#FAB040"
                  d="M31.993 1.848a5.862 5.862 0 015.854 5.84v5.817c0 1.02.827 1.848 1.848 1.848h5.825a5.862 5.862 0 015.854 5.862v10.778a5.854 5.854 0 01-5.854 5.854h-5.825a1.826 1.826 0 00-1.3.54 1.863 1.863 0 00-.548 1.308v5.825a5.854 5.854 0 01-5.854 5.854H21.23a5.862 5.862 0 01-5.855-5.854v-5.825c0-1.02-.827-1.848-1.848-1.848h-5.84a5.862 5.862 0 01-5.839-5.854V21.23c0-3.229 2.61-5.85 5.84-5.862h5.84c1.02 0 1.847-.827 1.847-1.848V7.688a5.862 5.862 0 015.855-5.84h10.763m0-1.848H21.23a7.71 7.71 0 00-7.703 7.688v5.817h-5.84A7.717 7.717 0 000 21.23v10.763a7.71 7.71 0 007.688 7.702h5.84v5.825a7.71 7.71 0 007.702 7.702h10.763a7.695 7.695 0 007.702-7.702v-5.825h5.825a7.695 7.695 0 007.702-7.702V21.23a7.71 7.71 0 00-7.702-7.71h-5.825V7.688A7.71 7.71 0 0031.993 0z"
                 />
                <path
                  fill="#EC008C"
                  d="M31.993 46.222H21.23a.74.74 0 01-.702-.702V32.695H7.688a.74.74 0 01-.703-.702V21.23a.74.74 0 01.703-.702h12.84V7.688a.74.74 0 01.702-.703h10.763a.74.74 0 01.702.703v12.84H45.52a.74.74 0 01.702.702v10.763a.74.74 0 01-.702.702H32.695V45.52a.74.74 0 01-.702.702zm-10.068-1.404h9.373V31.993a.695.695 0 01.2-.496.74.74 0 01.495-.207h12.825v-9.365H31.993a.695.695 0 01-.695-.695V8.427h-9.373V21.23a.695.695 0 01-.695.695H8.427v9.365H21.23a.74.74 0 01.695.74v12.788z"
                 />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default IconHealth;
